import { t } from "i18next";
import * as yup from "yup";

export const notificationValidationSchema = yup.object({
  image: yup.object().nullable(),
  title: yup.string().required(t("Title is required")),
  description: yup
    .string()
    .required(t("Description is required"))
    .min(10, t("Description must be longer than or equal to 10 characters")),
  postingDate: yup.date().required(t("Posting date is required")),
  postingTime: yup.string().required(t("Posting time is required")),
  productVariants: yup.array().of(yup.object())
});
